export const en = {
    cancel: 'Cancel',
    dayBudgetLimit: 'Budget limit',
    set: 'Set',
    walletDayBudgetIsSet:
        'The display mode "{mode}" is set for shared account and a daily budget limit of {sum} {currency} has been set. Enter a smaller value to limit the campaign\'s daily budget.'
};
